import axios from "axios";
import React, { useEffect, useState } from "react";
import { DeletedFilter, RestoreAction } from "../../components/common/DeletedFilter";
import { ROLE_LIST, ROLE_DELETE,
  ROLE_RESTORE, ROLE_STATUS_UPDATE, ROLE_IMPACT, ROLE_LOGS } from "../../routes/routes";
import { PAGINATE, ROLE_DELETED } from "../../constant/constant";
import { toast } from "react-toastify";
import {
  NoDataFound,
  Pagination,
  checkEmptyOrNull,
} from "../../components/Utils";
import { usePermission } from "../../hooks/usePermission";
import Loader from "../../components/common/Loader"; // Import the loader component
import { Link, useNavigate } from "react-router-dom";
import { Modal, Form } from "react-bootstrap";
import StickyTable from "../../components/common/StickyTable";
import Select from "react-select";
import { ADMIN_ROLE_TYPE_OPTIONS } from "../Admin/adminTypeConfig";

const RoleList = () => {
  const { hasPermission } = usePermission();
  // ## State Variable Declaration
  const [data, setData] = useState([]);
  const [paginator, setPaginator] = useState({});
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [refresh, setRefresh] = useState(false); // New state to trigger refresh
  const [confirmation, setConfirmation] = useState({});
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [deletedFilter, setDeletedFilter] = useState("all");
  const [adminTypeFilter, setAdminTypeFilter] = useState("");
  const [detailData, setDetailData] = useState({});
  const [detailsModal, setDetailModal] = useState(false);
  const [deactivateModal, setDeactivateModal] = useState(false);
  const [deactivateTarget, setDeactivateTarget] = useState(null);
  const [logModal, setLogModal] = useState(false);
  const [logData, setLogData] = useState([]);
  const [logLoading, setLogLoading] = useState(false);
  const [logRole, setLogRole] = useState(null);
  const [logAssignedAdmins, setLogAssignedAdmins] = useState([]);

  /**
   * @API Cateogry List API's call
   */
  const navigate = useNavigate();

  const HandleDelete = async (RoleId) => {
    try {
      axios
        .delete(ROLE_DELETE + RoleId)
        .then((res) => {
          if (res.status === 200 && res.data.success) {
            toast.success(ROLE_DELETED);
            setRefresh((prevRefresh) => !prevRefresh);
            navigate("/roles");
          }
        })
        .catch((err) => {
          if (err.response) {
            toast.error(err.response?.data?.msg || "Failed to delete role");
          }
        });
    } catch (error) {
      // Handle errors
      console.error(error);
    }
  };


  const HandleRestore = async (recordId) => {
    try {
      axios
        .post(ROLE_RESTORE + recordId)
        .then((res) => {
          if (res.status === 200 && res.data.success) {
            toast.success("Restored successfully");
            setRefresh((prevRefresh) => !prevRefresh);
          } else {
            toast.error(res?.data?.msg || "Failed to restore");
          }
        })
        .catch((err) => {
          toast.error(err.response?.data?.msg || "Failed to restore");
        });
    } catch (error) {
      console.error(error);
    }
  };

  const handleStatusToggle = async (roleId, status) => {
    try {
      axios
        .post(ROLE_STATUS_UPDATE + roleId, { status })
        .then((res) => {
          if (res.status === 200 && res.data.success) {
            toast.success(res.data.msg || "Status updated successfully");
            setData((prevData) =>
              prevData.map((item) =>
                item.id === roleId ? { ...item, status } : item
              )
            );
          } else {
            toast.error(res?.data?.msg || "Failed to update status");
          }
        })
        .catch((err) => {
          toast.error(err?.response?.data?.msg || "Failed to update status");
        });
    } catch (error) {
      console.error(error);
    }
  };

  const openDeactivateConfirmation = (role) => {
    setDeactivateTarget(role);
    setDeactivateModal(true);
  };

  const fetchRoleLogs = async (role) => {
    setLogRole(role);
    setLogAssignedAdmins(role?.assigned_admins || []);
    setLogModal(true);
    setLogLoading(true);
    try {
      const res = await axios.get(ROLE_LOGS + role.id);
      if (res.status === 200 && res.data.success) {
        setLogData(res.data.data || []);
        if (res.data?.extra?.assigned_admins) {
          setLogAssignedAdmins(res.data.extra.assigned_admins);
        }
      } else {
        setLogData([]);
      }
    } catch (error) {
      console.error(error);
      setLogData([]);
      toast.error(error?.response?.data?.msg || "Failed to load activity logs");
    } finally {
      setLogLoading(false);
    }
  };

  const cleanAccessName = (name, action) => {
    let clean = (name || "").trim();
    const act = (action || "").trim();
    if (act) {
      const regex = new RegExp(`\\s+${act}$`, "i");
      clean = clean.replace(regex, "").trim();
    }
    return clean || act;
  };

  const formatPermissionName = (perm) => {
    if (!perm) return "";
    let action = "View";
    let accessName = "";

    if (typeof perm === "object") {
      action = perm.action || "View";
      accessName = perm.access_name || perm.name || perm.slug || "";
      if (perm.label && !perm.access_name) {
        return perm.label;
      }
    } else {
      const slug = String(perm).trim();
      let base = slug;
      if (slug.endsWith("-view") || slug.endsWith("-list")) {
        action = "View";
        base = slug.replace(/-(view|list)$/, "");
      } else if (slug.endsWith("-create") || slug.endsWith("-add")) {
        action = "Add";
        base = slug.replace(/-(create|add)$/, "");
      } else if (slug.endsWith("-edit") || slug.endsWith("-update")) {
        action = "Edit";
        base = slug.replace(/-(edit|update)$/, "");
      } else if (slug.endsWith("-delete")) {
        action = "Delete";
        base = slug.replace(/-delete$/, "");
      } else if (slug.endsWith("-export")) {
        action = "Export";
        base = slug.replace(/-export$/, "");
      }

      if (base.startsWith("dashboard-")) {
        base = base.replace(/^dashboard-/, "");
      }

      accessName = base
        .split("-")
        .filter(Boolean)
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ");
    }

    accessName = cleanAccessName(accessName, action);
    return `${accessName} - ${action}`;
  };

  const cleanSummary = (summary) => {
    if (!summary) return "";
    let clean = summary.replace(/\s*\([^)]*\)/g, "").trim();
    clean = clean
      .replace(/granted/gi, "enabled")
      .replace(/revoked/gi, "disabled")
      .replace(/added/gi, "enabled")
      .replace(/removed/gi, "disabled");
    clean = clean.replace(/:\s*\+(\d+)\s+enabled/gi, ": +$1");
    clean = clean.replace(/:\s*-(\d+)\s+disabled/gi, ": -$1");
    return clean;
  };

  const groupPermissionsByAccessName = (permList) => {
    if (!Array.isArray(permList) || permList.length === 0) return [];
    const groups = {};

    permList.forEach((perm) => {
      let action = "View";
      let accessName = "";
      if (typeof perm === "object" && perm !== null) {
        action = perm.action || "View";
        accessName = perm.access_name || perm.name || "";
      } else {
        const slug = String(perm).trim();
        let base = slug;
        if (slug.endsWith("-view") || slug.endsWith("-list")) {
          action = "View";
          base = slug.replace(/-(view|list)$/, "");
        } else if (slug.endsWith("-create") || slug.endsWith("-add")) {
          action = "Add";
          base = slug.replace(/-(create|add)$/, "");
        } else if (slug.endsWith("-edit") || slug.endsWith("-update")) {
          action = "Edit";
          base = slug.replace(/-(edit|update)$/, "");
        } else if (slug.endsWith("-delete")) {
          action = "Delete";
          base = slug.replace(/-delete$/, "");
        } else if (slug.endsWith("-export")) {
          action = "Export";
          base = slug.replace(/-export$/, "");
        }

        if (base.startsWith("dashboard-")) {
          base = base.replace(/^dashboard-/, "");
        }

        accessName = base
          .split("-")
          .filter(Boolean)
          .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
          .join(" ");
      }

      accessName = cleanAccessName(accessName, action);

      if (!groups[accessName]) {
        groups[accessName] = [];
      }
      if (action && !groups[accessName].includes(action)) {
        groups[accessName].push(action);
      }
    });

    return Object.keys(groups).map((accessName) => {
      const actions = groups[accessName];
      if (actions.length === 0) return accessName;
      return `${accessName} - ${actions.join(", ")}`;
    });
  };

  useEffect(() => {
    const adminTypeQuery = adminTypeFilter ? `&admin_type=${adminTypeFilter}` : "";
    axios
      .get(ROLE_LIST + `?type=${PAGINATE}&page=${page}&perPage=${perPage}&deleted=${deletedFilter}${adminTypeQuery}`)
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          setData(response.data.data.roles);
          setPaginator({
            prev: response.data.data.prev_page_url != null,
            next: response.data.data.next_page_url != null,
            total: response.data.data.total,
            current: response.data.data.current_page,
            last: response.data.data.last_page,
          });
        }
      })
      .catch((err) => {
        console.error("Failed to load roles:", err);
        setData([]);
      })
      .finally(() => {
        setLoading(false); // Set loading to false after data is fetched
      });
  }, [page, refresh, perPage, deletedFilter, adminTypeFilter]);

  return (
    <div className="content-wrapper">
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Roles & Permissions</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">Roles & Permissions List</span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                {hasPermission("roles-create") && (
                  <Link to={"/create/role"}>
                    <button
                      type="button"
                      className="btn rounded-pill btn-primary ibutton"
                    >
                      <span className="tf-icons bx bx-plus"></span>&nbsp; Add
                    </button>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex-grow-1">
        <div className="card icard sticky-table-card">
         
          <div className="container-fluid f_containter">
            <div className="row mb-4">
              <div className="col-md-3">
                <div className="mb-3">
                  <label className="form-label" htmlFor="admin_type_filter">
                    Admin Type
                  </label>
                  <Select
                    isClearable
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                    name="admin_type_filter"
                    inputId="admin_type_filter"
                    placeholder="All"
                    options={ADMIN_ROLE_TYPE_OPTIONS}
                    value={
                      adminTypeFilter
                        ? ADMIN_ROLE_TYPE_OPTIONS.find(
                            (opt) => opt.value === Number(adminTypeFilter)
                          ) || null
                        : null
                    }
                    onChange={(selected) => {
                      setPage(1);
                      setAdminTypeFilter(selected ? selected.value : "");
                    }}
                  />
                </div>
              </div>
              <DeletedFilter
                value={deletedFilter}
                includeAll={true}
                onChange={(value) => {
                  setPage(1);
                  setDeletedFilter(value);
                }}
              />
            </div>
          </div>
          {/* Pagination Component */}
          {data.length > 0 && (
            <Pagination
              paginator={paginator}
              page={(no) => setPage(no)}
              perPage={perPage}
              setPerPage={setPerPage}
            />
          )}
          <StickyTable refreshDeps={[data, loading]}>
            <table className="table table-striped itable">
              <thead>
                <tr>
                  <th>Sl. No.</th>
                  <th>Role Name</th>
                  <th>Admin Type</th>
                  <th style={{ textAlign: "center", width: "10%" }}>Status</th>
                  <th style={{ textAlign: "center", width: "10%" }}>Action</th>
                </tr>
              </thead>
              <tbody className="table-border-bottom-0">
                {loading ? (
                  <Loader loading={loading} colspan="5" />
                ) : data.length > 0 ? (
                  data.map((role, i) => {
                    const isDeleted = Number(role?.is_delete) === 1 || deletedFilter === "yes";
                    return (
                    <tr key={i}>
                      <td>{role?.sno}</td>
                      <td>{role?.name}</td>
                      <td>
                        {role?.admin_type_name && role.admin_type_name !== "-" ? (
                          <span className=""> 
                            {role.admin_type_name}
                          </span> 
                        ) : (
                          <span className="text-muted">-</span>
                        )}
                      </td>
                      <td>
                        <div className="d-flex justify-content-center">
                          {isDeleted ? (
                            <span className="badge bg-label-danger">Deleted</span>
                          ) : (
                            <Form.Check
                              type="switch"
                              id={`role-switch-${role?.id || i}`}
                              disabled={!hasPermission("roles-edit")}
                              checked={role?.status === 1}
                              onChange={(e) => {
                                if (role?.status === 1) {
                                  openDeactivateConfirmation(role);
                                } else {
                                  handleStatusToggle(role?.id, 1);
                                }
                              }}
                            />
                          )}
                        </div>
                      </td>
                      <td style={{ textAlign: "right" }}>{isDeleted ? (
                        hasPermission("roles-list") && (
                          <>
                            <button
                              className="badge bg-label-info me-1 border-0"
                              data-bs-toggle="tooltip"
                              data-bs-offset="0,4"
                              data-bs-placement="top"
                              data-bs-html="true"
                              title="View"
                              data-bs-original-title="View"
                              onClick={() => {
                                setDetailModal(true);
                                setDetailData(role);
                              }}
                            >
                              <i className="bx bx-show"></i>
                            </button>
                            <RestoreAction
                          onClick={() => {
                            setConfirmationModal(true);
                            setConfirmation({
                              message: "Are you sure you want to restore?",
                              fn: () => HandleRestore(role?.id),
                            });
                          }}
                            />
                          </>
                        )
                      ) : (
                        <>
                        {hasPermission("roles-list") && (
                          <button
                            className="badge bg-label-info me-1 border-0"
                            data-bs-toggle="tooltip"
                            data-bs-offset="0,4"
                            data-bs-placement="top"
                            data-bs-html="true"
                            title="View"
                            data-bs-original-title="View"
                            onClick={() => {
                              setDetailModal(true);
                              setDetailData(role);
                            }}
                          >
                            <i className="bx bx-show"></i>
                          </button>
                        )}

                        {hasPermission("roles-list") && (
                          <button
                            className="badge bg-label-warning me-1 border-0"
                            data-bs-toggle="tooltip"
                            data-bs-offset="0,4"
                            data-bs-placement="top"
                            data-bs-html="true"
                            title="Activity History"
                            data-bs-original-title="Activity History"
                            onClick={() => fetchRoleLogs(role)}
                          >
                            <i className="bx bx-history"></i>
                          </button>
                        )}

                        {hasPermission("roles-edit") && (
                          <Link to={`/role/${role.id}/edit`}>
                            <button
                              className="badge bg-label-success me-1 border-0"
                              data-bs-toggle="tooltip"
                              data-bs-offset="0,4"
                              data-bs-placement="top"
                              data-bs-html="true"
                              title="Edit"
                              data-bs-original-title="Edit"
                            >
                              <i className="bx bx-pencil"></i>
                            </button>
                          </Link>
                        )}

                        {hasPermission("roles-delete") && (
                          <button
                            onClick={() => {
                              setConfirmationModal(true);
                              setConfirmation({
                                message:
                                  "Are you sure, you want to delete?",
                                fn: () => HandleDelete(role?.id),
                              });
                            }}
                            className="badge bg-label-danger me-1 border-0"
                            data-bs-toggle="tooltip"
                            data-bs-offset="0,4"
                            data-bs-placement="top"
                            data-bs-html="true"
                            title="Delete"
                            data-bs-original-title="Delete"
                          >
                            <i className="bx bx-trash"></i>
                          </button>
                        )}
                      </>
                      )}</td>
                    </tr>
                    );
                  })
                ) : (
                  <NoDataFound colspan="5" message="No Data Found" />
                )}
              </tbody>
            </table>
          </StickyTable>
          {/* Pagination Component */}
          {data.length > 0 && (
            <Pagination
              paginator={paginator}
              page={(no) => setPage(no)}
              perPage={perPage}
              setPerPage={setPerPage}
            />
          )}
        </div>
      </div>

      <Modal
        show={confirmationModal}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setConfirmationModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton className="no-border"></Modal.Header>
        <Modal.Body className="idel_popup">
          <div className="icon_holder">
            <div className="pop_del_icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#CF2030"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                <line x1="10" y1="11" x2="10" y2="17"></line>
                <line x1="14" y1="11" x2="14" y2="17"></line>
              </svg>
            </div>
          </div>
          <h6 className="text-center modal_title">{confirmation?.message}</h6>
          <div className="text-center">
            <button
              onClick={() => {
                setConfirmationModal(false);
                setConfirmation({});
              }}
              className="btn btn-danger btn-sm me-2 iclose_btn"
            >
              No
            </button>
            <button
              onClick={() => {
                confirmation.fn();
                setConfirmationModal(false);
                setConfirmation({});
              }}
              className="btn btn-success btn-sm isubmit_button"
            >
              Yes
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {/* Deactivate Role Confirmation Alert Popup */}
      <Modal
        show={deactivateModal}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {
          setDeactivateModal(false);
          setDeactivateTarget(null);
        }}
        backdrop="static"
      >
        <Modal.Header closeButton className="no-border"></Modal.Header>
        <Modal.Body className="idel_popup">
          <div className="icon_holder">
            <div className="pop_del_icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#CF2030"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                <line x1="12" y1="9" x2="12" y2="13"></line>
                <line x1="12" y1="17" x2="12.01" y2="17"></line>
              </svg>
            </div>
          </div>
          <h6 className="text-center modal_title mb-2">
            Deactivate "{deactivateTarget?.name}"?
          </h6>
          <p
            className="text-center text-muted mb-4 px-2"
            style={{ fontSize: "13px", lineHeight: "1.5" }}
          >
          <p style={{ color: "#404040" }}>
            Deactivating this role will revoke access and log out all active administrators across the associated hierarchy (Country, State, City, Region, Circle).
          </p>
          </p>
          <div className="text-center">
            <button
              onClick={() => {
                setDeactivateModal(false);
                setDeactivateTarget(null);
              }}
              className="btn btn-secondary btn-sm me-2 iclose_btn"
            >
              No
            </button>
            <button
              onClick={() => {
                if (deactivateTarget) {
                  handleStatusToggle(deactivateTarget.id, 0);
                }
                setDeactivateModal(false);
                setDeactivateTarget(null);
              }}
              className="btn btn-danger btn-sm isubmit_button"
            >
              Yes, Deactivate
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={detailsModal}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setDetailModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="modal_title1"
          >
            Role & Permissions Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card-body py-0">
            <div className="row">
              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Role Name</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.name)}
                  </span>
                </div>
              </div>
              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Admin Type</label>
                  <span className="d-block font-weight-600">
                    {detailData?.admin_type_name && detailData.admin_type_name !== "-" ? (
                      <span className="badge bg-label-info font-size-12">
                        {detailData.admin_type_name}
                      </span>
                    ) : (
                      "-"
                    )}
                  </span>
                </div>
              </div>
              <div className="col-md-4">
                <div className="mb-4">
                  <label className="form-label m-0">Status</label>
                  <span className="d-block font-weight-600">
                    {detailData?.is_delete === 1 ? (
                      <span className="badge bg-label-danger">Deleted</span>
                    ) : detailData?.status === 1 ? (
                      <span className="badge bg-label-success">Active</span>
                    ) : (
                      <span className="badge bg-label-secondary">Inactive</span>
                    )}
                  </span>
                </div>
              </div>

              <div className="col-md-12">
                <div className="mb-3">
                  <label className="form-label mb-2">Assigned Administrators</label>
                  <div className="d-flex flex-wrap gap-2 mb-4">
                    {Array.isArray(detailData?.assigned_admins) && detailData.assigned_admins.length > 0 ? (
                      detailData.assigned_admins.map((admin, idx) => (
                        <div
                          key={idx}
                          className="badge px-3 py-2 text-start"
                          style={{
                            fontSize: "0.85rem",
                            borderRadius: "8px",
                            backgroundColor: "#E8F0FE",
                            color: "#1A73E8",
                            border: "1px solid #c2d7fc",
                          }}
                        >
                          <i className="bx bx-user me-1"></i>
                          <span className="fw-bold">{admin.name}</span>
                          {admin.email && <span className="ms-1 text-muted">({admin.email})</span>}
                        </div>
                      ))
                    ) : (
                      <span className="text-muted">No administrators assigned yet</span>
                    )}
                  </div>

                  <label className="form-label mb-2">Permissions</label>
                  <div className="d-flex flex-wrap gap-2">
                    {Array.isArray(detailData?.permissions) &&
                    detailData.permissions.length > 0 ? (
                      detailData.permissions.map((p, i) => {
                        const parts = p.split(" - ");
                        const displayText =
                          parts.length === 2
                            ? `${parts[1]} - ${parts[0].toUpperCase()}`
                            : p;
                        return (
                          <span
                            key={i}
                            className="badge px-3 py-2"
                            style={{
                              fontSize: "0.875rem",
                              borderRadius: "8px",
                              backgroundColor: "#F6E9EA",
                              color: "#CF2030",
                              border: "1px solid #dfcfcf",
                            }}
                          >
                            {displayText}
                          </span>
                        );
                      })
                    ) : (
                      <span className="text-muted">
                        No permissions assigned
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-outline-warning btn-sm me-auto"
            onClick={() => {
              setDetailModal(false);
              fetchRoleLogs(detailData);
            }}
          >
            <i className="bx bx-history me-1"></i> View Activity History
          </button>
          <button
            type="button"
            className="btn btn-secondary ibutton"
            data-bs-dismiss="modal"
            onClick={() => setDetailModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>

      {/* Role Activity Logs Modal */}
      <Modal
        show={logModal}
        size="xl"
        aria-labelledby="role-activity-logs-modal"
        centered
        onHide={() => setLogModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="role-activity-logs-modal" className="modal_title1 d-flex align-items-center">
            <i className="bx bx-history me-2 text-warning fs-4"></i>
            Activity History &mdash;&nbsp;<span className="text-primary">{logRole?.name}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
          {logLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-2 text-muted">Loading activity logs...</p>
            </div>
          ) : logData.length === 0 ? (
            <div className="text-center py-5">
              <div className="mb-2">
                <i className="bx bx-receipt text-muted" style={{ fontSize: "48px" }}></i>
              </div>
              <h6 className="text-muted">No activity logs recorded yet for this role.</h6>
              <p className="small text-muted mb-0">Modifications like permission changes, name edits, and status toggles will appear here.</p>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover align-middle">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: "15%" }}>Date & Time</th>
                    <th style={{ width: "13%" }}>Action</th>
                    <th style={{ width: "20%" }}>Assigned Member</th>
                    <th style={{ width: "16%" }}>Performed By</th>
                    <th style={{ width: "36%" }}>Modification Details</th>
                  </tr>
                </thead>
                <tbody>
                  {logData.map((log, idx) => {
                    const details = typeof log.details === "string" ? JSON.parse(log.details || "{}") : (log.details || {});
                    let actionBadgeClass = "bg-label-primary";
                    let actionLabel = log.action;
                    if (log.action === "CREATE") {
                      actionBadgeClass = "bg-label-success";
                      actionLabel = "Created";
                    } else if (log.action === "UPDATE_PERMISSIONS") {
                      actionBadgeClass = "bg-label-warning";
                      actionLabel = "Permissions Modified";
                    } else if (log.action === "UPDATE_NAME") {
                      actionBadgeClass = "bg-label-info";
                      actionLabel = "Name Changed";
                    } else if (log.action === "STATUS_CHANGE") {
                      actionBadgeClass = "bg-label-secondary";
                      actionLabel = "Status Toggled";
                    } else if (log.action === "DELETE") {
                      actionBadgeClass = "bg-label-danger";
                      actionLabel = "Deleted";
                    } else if (log.action === "RESTORE") {
                      actionBadgeClass = "bg-label-success";
                      actionLabel = "Restored";
                    } else if (log.action === "ROLE_ASSIGNMENT" || log.action === "ROLE_ASSIGNED") {
                      actionBadgeClass = "bg-label-primary";
                      actionLabel = "Role Assigned";
                    }

                    return (
                      <tr key={log.id || idx}>
                        <td className="text-nowrap">
                          <div className="d-flex align-items-center">
                            <i className="bx bx-calendar me-1 text-muted"></i>
                            <span style={{ fontSize: "12.5px" }}>{log.created_at_time || log.created_at}</span>
                          </div>
                        </td>
                        <td>
                          <span className={`badge ${actionBadgeClass}`} style={{ fontSize: "11px", fontWeight: "600" }}>
                            {actionLabel}
                          </span>
                        </td>
                        <td>
                          {(() => {
                            const assignedName = details?.admin_name || details?.target_admin_name;
                            const assignedEmail = details?.admin_email || details?.target_admin_email;
                            if (assignedName) {
                              return (
                                <div>
                                  <div className="fw-semibold text-primary" style={{ fontSize: "13px" }}>
                                    {assignedName}
                                  </div>
                                  {assignedEmail && (
                                    <div className="text-secondary small" style={{ fontSize: "11.5px" }}>
                                      {assignedEmail}
                                    </div>
                                  )}
                                </div>
                              );
                            }
                            if (logAssignedAdmins && logAssignedAdmins.length > 0) {
                              return (
                                <div className="d-flex flex-column gap-1">
                                  {logAssignedAdmins.map((a, ai) => (
                                    <div key={ai} className="mb-1">
                                      <div className="fw-semibold text-primary" style={{ fontSize: "12.5px" }}>
                                        {a.name}
                                      </div>
                                      {a.email && (
                                        <div className="text-secondary small" style={{ fontSize: "11.5px" }}>
                                          {a.email}
                                        </div>
                                      )}
                                    </div>
                                  ))}
                                </div>
                              );
                            }
                            return <span className="text-muted">—</span>;
                          })()}
                        </td>
                        <td>
                          <div className="fw-semibold text-dark" style={{ fontSize: "13px" }}>
                            {log.admin_name || "System"}
                          </div>
                          {log.admin_email && (
                            <div className="text-secondary small" style={{ fontSize: "11.5px" }}>
                              {log.admin_email}
                            </div>
                          )}
                          <small className="badge bg-label-dark mt-1" style={{ fontSize: "10px" }}>
                            {log.admin_level || "Admin"}
                          </small>
                        </td>
                        <td>
                          <div className="fw-semibold text-dark mb-1" style={{ fontSize: "13px" }}>
                            {cleanSummary(log.summary)}
                          </div>

                          {/* Diffs for Permissions & Initial Permissions */}
                          {log.details && (log.details.added?.length > 0 || log.details.removed?.length > 0 || log.details.permissions?.length > 0) && (
                            <div className="mt-2 pt-1 border-top">
                              {((log.details.added && log.details.added.length > 0) || (log.details.permissions && log.details.permissions.length > 0)) && (
                                <div className="mb-1">
                                  <div className="d-flex flex-wrap gap-1 mt-1">
                                    {groupPermissionsByAccessName(log.details.added && log.details.added.length > 0 ? log.details.added : log.details.permissions).map((groupedText, pIdx) => (
                                      <span
                                        key={pIdx}
                                        className="badge"
                                        style={{
                                          fontSize: "11px",
                                          backgroundColor: "#E8FADF",
                                          color: "#28a745",
                                          border: "1px solid #c3e6cb",
                                        }}
                                      >
                                        + {groupedText}
                                      </span>
                                    ))}
                                  </div>
                                </div>
                              )}
                              {log.details.removed?.length > 0 && (
                                <div className="mt-1">
                                  {false && <span className="badge bg-label-danger me-1" style={{ fontSize: "10px" }}>
                                    -{log.details.removed.length} Removed
                                  </span>}
                                  <div className="d-flex flex-wrap gap-1 mt-1">
                                    {groupPermissionsByAccessName(log.details.removed).map((groupedText, pIdx) => (
                                      <span
                                        key={pIdx}
                                        className="badge"
                                        style={{
                                          fontSize: "11px",
                                          backgroundColor: "#FCE8E6",
                                          color: "#CF2030",
                                          border: "1px solid #fad2cf",
                                        }}
                                      >
                                        - {groupedText}
                                      </span>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </div>
                          )}

                          {/* Diffs for Role Name */}
                          {log.details?.old_name && log.details?.new_name && (
                            <div className="small text-muted mt-1">
                              <span className="text-decoration-line-through text-danger me-1">{log.details.old_name}</span>
                              <i className="bx bx-right-arrow-alt align-middle me-1"></i>
                              <span className="fw-bold text-success">{log.details.new_name}</span>
                            </div>
                          )}

                          {/* Diffs for Status */}
                          {log.details?.old_status_label && log.details?.new_status_label && (
                            <div className="small text-muted mt-1">
                              <span className={`badge ${log.details.old_status === 1 ? 'bg-label-success' : 'bg-label-secondary'} me-1`}>
                                {log.details.old_status_label}
                              </span>
                              <i className="bx bx-right-arrow-alt align-middle me-1"></i>
                              <span className={`badge ${log.details.new_status === 1 ? 'bg-label-success' : 'bg-label-secondary'}`}>
                                {log.details.new_status_label}
                              </span>
                            </div>
                          )}

                          {/* Diffs for Role Assignment (Previous assigned role and Newly assigned role) */}
                          {(details?.new_role_name || details?.previous_role_name || log.action === "ROLE_ASSIGNMENT" || log.action === "ROLE_ASSIGNED") && (
                            <div className="mt-2 pt-1 border-top">
                              <div className="d-flex align-items-center flex-wrap gap-2 small">
                                <div>
                                  <span className="text-muted me-1">Previous Role:</span>
                                  <span
                                    className={`badge ${
                                      details.previous_role_name &&
                                      details.previous_role_name !== "None"
                                        ? "bg-label-danger"
                                        : "bg-label-secondary"
                                    }`}
                                  >
                                    {details.previous_role_name || "None"}
                                  </span>
                                </div>
                                <i className="bx bx-right-arrow-alt text-muted fs-5 align-middle"></i>
                                <div>
                                  <span className="text-muted me-1">Newly Assigned:</span>
                                  <span className="badge bg-label-success">
                                    {details.new_role_name || logRole?.name || "Assigned"}
                                  </span>
                                </div>
                              </div>
                            </div>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary ibutton"
            onClick={() => setLogModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default RoleList;
